let TimeUtils = {};

TimeUtils.getTimeAgo = (timestamp) => {

  if (!timestamp)
    return '';

  // inflect = $filter('inflect');

  let now = new Date().getTime();
  let time = new Date(timestamp).getTime();

  let secondsAgo = (now-time)/1000;

  if (secondsAgo < 60)
    return 'Just now';

  let minutesAgo = secondsAgo/60;

  let unit = '';
  let amount = '';
  
  if (minutesAgo < 60)
  {
    amount = Math.floor(minutesAgo);
    unit = 'minute';
  }
  else 
  {
    let hoursAgo = minutesAgo/60;
    if (hoursAgo < 24)
    { 
      amount = Math.floor(hoursAgo);
      unit = 'hour';
    }
    else
    {
      let daysAgo = hoursAgo/24;
      if (daysAgo <= 30)
      {
        amount = Math.floor(daysAgo);
        unit = 'day';
      }
      else
      {
        let monthsAgo = daysAgo/30;
        amount = Math.floor(monthsAgo);
        unit = 'month';
      }
      
    }
    
  }

  if (amount > 1)
    unit += 's';

  return amount + ' ' + unit + ' ago';

};

module.exports = TimeUtils;


// WEBPACK FOOTER //
// ./src/js/services/TimeUtils.js